<script>
import { Line } from "vue-chartjs";

export default {
  extends: Line,
  props: ["data", "options", "refresh"],
  data() {
    return {
      ymax: 250,
      defaultData: {
        labels: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
        ],
        datasets: [
          {
            label: 'Account',
            backgroundColor: '#3cb450',
            // borderColor: 'rgba(255,255,255,.55)',
            data: [2500, 4500, 8400, 8400, 5100, 5500, 4000],
            fill: false,
            borderColor: '#3cb450',
            tension: 0.1
          }
        ]
      },
      defaultOptions: {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: false,
          text: "Demo Data"
        },
        legend: {
          display: false
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                drawOnChartArea: false
              }
            }
          ],
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                maxTicksLimit: 5,
                stepSize: Math.ceil(this.ymax / 5),
                /*  max: this.y_axis */
                max: this.ymax
              },
              gridLines: {
                display: true
              }
            }
          ]
        },
        elements: {
          point: {
            radius: 5,
            hitRadius: 10,
            hoverRadius: 4,
            hoverBorderWidth: 3,

          }
        }
      },
      chartData: null,
      chartOptions: null
    };
  },
  mounted() {
    this.render();
  },
  watch: {
    data: {
      // immediate: true,
      handler(newVal, oldVal) {
        if (newVal) {
          this.render();
        }
      }
    },
  },
  methods: {
    async render() {
      if (this.data) {
        this.chartData = this.data;
      } else {
        this.chartData = this.defaultData;
      }
      if (this.options) {
        this.chartOptions = this.options;
      } else {
        this.chartOptions = this.defaultOptions;
      }

      this.renderChart(this.chartData, this.chartOptions);
    }
  }
};
</script>